var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeTerrorist01 = function SvgTypeTerrorist01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "type_terrorist-01_svg2__a",
    x1: -22.18,
    x2: 138.95,
    y1: 125.2,
    y2: -21.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_terrorist-01_svg2__a",
    id: "type_terrorist-01_svg2__b",
    x1: -9.72,
    x2: 151.41,
    y1: 138.88,
    y2: -7.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_terrorist-01_svg2__a",
    id: "type_terrorist-01_svg2__c",
    x1: 41.75,
    x2: 202.88,
    y1: 195.36,
    y2: 48.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_terrorist-01_svg2__a",
    id: "type_terrorist-01_svg2__d",
    x1: -14.6,
    x2: 146.53,
    y1: 133.52,
    y2: -13.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#type_terrorist-01_svg2__a",
    id: "type_terrorist-01_svg2__e",
    x1: 34.59,
    x2: 195.72,
    y1: 187.51,
    y2: 40.68
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M48.83 53.03H62.4c.68 0 1.02.68.68 1.02-2.03 3.39-8.82 11.87-14.92 0 0-.34.34-1.02.68-1.02Z",
    style: {
      fill: "url(#type_terrorist-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3 53.03h13.57c.68 0 1.02.68.68 1.02-2.03 3.39-8.82 11.87-14.92 0 0-.34.34-1.02.68-1.02Z",
    style: {
      fill: "url(#type_terrorist-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.71 47.94c3.73-3.39 2.71-9.5-1.7-11.87l-14.58-7.8c-3.39-1.7-7.46-.68-9.5 2.37l-23.06 32.9-3.05-2.03c-.68-.34-1.36-.34-1.7.34l-8.14 12.89-2.03-1.36c-1.02-.68-2.37-.34-3.05 1.02l-16.28 28.15 11.19 3.39c7.8 2.37 14.24 7.8 17.97 14.92l4.41-7.8c7.46 1.36 14.58 5.09 19.67 10.51 1.02 1.02 3.05 1.02 3.73-.34l4.07-6.78c.68-1.02.34-2.03-.34-2.71-3.05-3.05-6.44-5.43-10.17-7.46-3.39-1.7-7.12-3.05-10.85-4.07l2.71-4.75 21.03-2.71c1.36 0 2.03-1.36 2.03-2.37l-.68-9.5c0-1.36-1.36-2.37-2.71-2.03l-11.53 1.36 2.03-4.07 30.52-30.18Zm-17.29-9.49c3.05 0 5.43 2.37 5.43 5.43s-2.37 5.43-5.43 5.43-5.43-2.37-5.43-5.43 2.37-5.43 5.43-5.43",
    style: {
      fill: "url(#type_terrorist-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52 10.64c-24.42 0-44.09 19.67-44.09 44.09s19.67 51.21 44.09 51.21 44.09-26.79 44.09-51.21-19.67-44.09-44.09-44.09m31.54 46.46c-8.48 6.78-19.33 10.85-31.2 10.85s-22.72-4.07-31.2-10.85c-4.41-3.39-2.03-10.51 3.73-10.51h55.62c4.75.34 7.12 7.12 3.05 10.51",
    style: {
      fill: "url(#type_terrorist-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.76 113.73-23.4-7.12c-8.48 6.78-18.65 10.85-29.84 10.85s-21.37-4.07-29.84-10.85l-9.5 2.71v14.58H14.92v-9.83C6.1 117.47 0 126.28 0 135.78v46.12c0 4.07 3.39 7.46 7.46 7.46h124.8c4.07 0 7.46-3.39 7.46-7.46v-45.78c-.34-10.17-7.12-19.33-16.96-22.38Zm-92.58 40.02H14.92v-9.16h15.26zm0 5.77v9.16H14.92v-9.16zm0-29.85v9.16H14.92v-9.16zm-15.26 54.26v-9.5h15.26v9.5z",
    style: {
      fill: "url(#type_terrorist-01_svg2__e)"
    }
  }));
};
export default SvgTypeTerrorist01;